import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IInternalContactAlliance, internalContactAlliancesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { type IByInternalContactAllianceState } from './types';

const INTERNAL_CONTACT_ALLIANCE_MODULE = 'internalContactAlliance';

const state: IByInternalContactAllianceState = {
    byAlliance: new Map()
};

const dataObjectModule = getDataObjectsModule<IInternalContactAlliance>(internalContactAlliancesManager, 3);
const searchModule = getSearchModule<IInternalContactAlliance>(internalContactAlliancesManager);

const internalContactAllianceModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions, state, getters, mutations });
store.registerModule(INTERNAL_CONTACT_ALLIANCE_MODULE, internalContactAllianceModuleInstance);

export { INTERNAL_CONTACT_ALLIANCE_MODULE };
